import { create } from 'zustand';

/**
 * Organization Store - Manages organizations and sites
 * 
 * Usage:
 *   const organizations = useOrganizationStore(s => s.organizations);
 *   const sites = useOrganizationStore(s => s.sites);
 */
export const useOrganizationStore = create((set, get) => ({
  // ==========================================
  // DATA
  // ==========================================
  organizations: [],
  sites: [],
  
  // Organizations
  setOrganizations: (orgs) => set({ organizations: orgs }),
  
  addOrganization: (org) => set((state) => ({
    organizations: [...state.organizations, org],
  })),
  
  updateOrganization: (id, updates) => set((state) => ({
    organizations: state.organizations.map(org =>
      org.id === id ? { ...org, ...updates } : org
    ),
  })),
  
  removeOrganization: (id) => set((state) => ({
    organizations: state.organizations.filter(org => org.id !== id),
  })),
  
  // Sites
  setSites: (sites) => set({ sites }),
  
  addSite: (site) => set((state) => ({
    sites: [...state.sites, site],
  })),
  
  updateSite: (id, updates) => set((state) => ({
    sites: state.sites.map(site =>
      site.id === id ? { ...site, ...updates } : site
    ),
  })),
  
  removeSite: (id) => set((state) => ({
    sites: state.sites.filter(site => site.id !== id),
  })),
  
  // ==========================================
  // SELECTORS
  // ==========================================
  
  /**
   * Get organization by ID
   */
  getOrganizationById: (id) => {
    return get().organizations.find(org => org.id === id);
  },
  
  /**
   * Get site by ID
   */
  getSiteById: (id) => {
    return get().sites.find(site => site.id === id);
  },
  
  /**
   * Get all sites for a specific organization
   */
  getSitesByOrg: (orgId) => {
    return get().sites.filter(site => site.organization === orgId);
  },
  
  /**
   * Get cameras for a specific site (if you store them here)
   * Or this could be in cameraStore - your choice
   */
  getCamerasBySite: (siteId) => {
    // This would require cameras to be stored here
    // OR you could import from cameraStore
    // For now, returning empty array
    return [];
  },
}));
